import { createStore } from 'vuex'
import { System } from '@/classes/System'

export default createStore({
  state: {
    system: null as System | null,
    am5: 'AM5C322979838'
  },
  mutations: {
    addSystem (state, system:System) {
      state.system = system
    },
    removeSystem (state) {
      state.system = null
    }
  },
  modules: {}
})
